import React from 'react'
import IconSeta from 'images/black-friday-2025/ic-seta.svg'
import {
  Box,
  Imagem
} from './Styled'

export default function Seta () {
  return (
    <Box>
      <Imagem src={IconSeta} alt='Seta' />
    </Box>
  )
}
